import "./BetTableCmeter1.css";
import { userSiteAsset } from "../../../utils/userSiteAssets";
import { formatMinMax } from "../betTableBtable/oddsUtils";
import { formatBook } from "../../../utils/formatOdds";

// 1 Card Meter (cmeter1) — admin view only. Original admin classes (casino-table
// one-card-meter → meter-btns → meter-btn → meter-btn-box → btn-fighter-1/2; index.css):
// "Min:50 Max:1L" above, filled fighter button (red / yellow frame), book below.
// Feed: sub "Fighter A" / "Fighter B". Multiplier game — price 0 is NOT a lock, sirf gstatus.
const isSusp = (item) => !item || ["SUSPENDED", "0"].includes(String(item.gstatus || "").toUpperCase());

function Fighter({ label, item, btnClass, exposures, imgFirst }) {
  const n = parseFloat(exposures?.[label] ?? exposures?.[label.toLowerCase()]);
  const book = Number.isFinite(n) ? n : 0;
  const img = <img src={userSiteAsset("assets/img/fight.png")} alt="" />;
  return (
    <div className="meter-btn">
      <div className="text-right casino-min-max">
        Min:<span>{formatMinMax(item?.min)}</span> Max:<span>{formatMinMax(item?.max)}</span>
      </div>
      <div className={`meter-btn-box${isSusp(item) ? " suspended" : ""}`}>
        <button type="button" className={`btn ${btnClass}`}>
          {imgFirst && img}
          {label}
          {!imgFirst && img}
        </button>
      </div>
      <div className="casino-book text-center">
        <span className={book > 0 ? "book-green" : "book-red"}>{formatBook(book)}</span>
      </div>
    </div>
  );
}

export default function BetTableCmeter1({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const find = (nat) => sub.find((s) => s?.nat === nat);
  return (
    <div className="casino-table one-card-meter cmeter1-admin">
      <div className="casino-detail">
        <div className="meter-btns">
          <Fighter label="Fighter A" item={find("Fighter A")} btnClass="btn-fighter-1" exposures={exposures} />
          <Fighter label="Fighter B" item={find("Fighter B")} btnClass="btn-fighter-2" exposures={exposures} imgFirst />
        </div>
      </div>
    </div>
  );
}
